import React, { memo, useEffect } from "react";
import {
  fetchAllAccessories,
  selectAllAccessories,
  selectLoading,
  deleteAccessory,
  setAccessories,
} from "features/admin/Accessories/accessoriesAdminSlice";
import { batch, useDispatch, useSelector } from "react-redux";
import GridTable from "../Common/GridTable";
import { useNavigate } from "react-router-dom";
import { ColDef } from "@material-ui/data-grid";
import { setResponseMessage } from "features/admin/adminSlice";

interface AllAccessoriesTableProps {}
const columns: ColDef[] = [
  { sortable: false, field: "brand", headerName: "Марка", width: 300 },
  { sortable: false, field: "title", headerName: "Име", width: 500 },
  { sortable: false, field: "quantity", headerName: "Наличност", width: 150 },
];

const AccessoriesTable: React.FC<AllAccessoriesTableProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector(selectAllAccessories);
  const isLoading = useSelector(selectLoading);

  useEffect(() => {
    dispatch(fetchAllAccessories());
    return () => {
      dispatch(setAccessories([]));
    };
  }, [dispatch]);

  const add = () => {
    dispatch(setResponseMessage({ message: "", hasError: false }));
    navigate("/accessories/add");
  };

  const refresh = () => {
    batch(() => {
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(fetchAllAccessories());
    });
  };

  const remove = (ids: string[]) => {
    ids.forEach((id: string) => {
      const _refId = data.find(
        (item: { id: number }) => item.id === parseInt(id)
      )?.refId;
      _refId &&
        batch(() => {
          dispatch(setResponseMessage({ message: "", hasError: false }));
          dispatch(deleteAccessory(_refId));
        });
    });
    dispatch(fetchAllAccessories());
  };

  const edit = (id: string) => {
    const _refId = data.find((item: { id: number }) => item.id === parseInt(id))
      ?.refId;
    dispatch(setResponseMessage({ message: "", hasError: false }));
    _refId && navigate(`/accessories/edit/${_refId}`);
  };

  return (
    <GridTable
      add={add}
      refresh={refresh}
      remove={remove}
      edit={edit}
      data={data}
      columns={columns}
      isLoading={isLoading}
      searchProperty="title"
    />
  );
};

export default memo(AccessoriesTable);
